export default __webpack_public_path__ + "static/media/logo_dark.de46aa46.webp";